import type { TransferType, TransferTypeConfig } from '@/model/upsell/transfer';

export const transferCruise: Record<TransferType, TransferTypeConfig> = {
    taxi: {
        label: 'Privattransfer',
        subline: 'Premium-Direkttransfer zu Ihrem Schiff',
        icon: 'directionsCar',
        details: ['Direkte Route', 'Direkte Weiterreise ab Flughafen'],
        features: ['Privatfahrzeug', 'Direkter Transfer'],
        descriptions: ['Privattransfer vom Flughafen zu Ihrem Schiff'],
    },
    speedy_shuttle: {
        label: 'Speedy Shuttle',
        subline: 'Schnelleres und komfortabler Shuttle-Transfer',
        icon: 'airportShuttle300',
        details: ['Max. 6 Hotels', 'Max. 45 Minuten Wartedauer'],
        features: ['schneller Transfer', 'mehr Komfort'],
        descriptions: ['Bus Transfer ab Flughafen'],
    },
    shuttle: {
        label: 'Gemeinsames Shuttle',
        subline: 'Budgetfreundlicher Sammeltransfer mit mehreren Stopps',
        badge: 'beliebt',
        icon: 'airportShuttle',
        details: ['Bis zu 15 Stopps', 'Wartedauer am Flughafen'],
        features: ['gemeinsam mit anderen Reisenden', 'mehrere Stopps'],
        descriptions: [
            'Transfer im Bus-Shuttle vom Flughafen zu Ihrem Schiff',
            'Die Wartedauer am Flughafen kann bis zu 70 Minuten betragen.',
        ],
    },
};

export const transferLinks = {
    package: 'transfer',
    cruise: 'transfer-kreuzfahrt',
};
